import type { ReactNode } from 'react';

export const symbol_factory: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-80q-24.75 0-42.37-17.63Q80-115.25 80-140v-381q0-18.38 10-33.69Q100-570 117-577l201-85q15-6 28.5 2.25T360-635v35l159-64q15-6 28 3.07 13 9.06 13 24.93v76h320v420q0 24.75-17.62 42.37Q844.75-80 820-80H140Zm0-60h680v-359.8H500V-592l-200 80v-79l-160 71v380Zm310-100h60v-160h-60v160Zm-160 0h60v-160h-60v160Zm320 0h60v-160h-60v160Zm270-320H700l37-294q2-11 10.03-18.5 8.02-7.5 18.97-7.5h48q10.95 0 18.97 7.5Q841-865 843-854l37 294ZM140-140h680-680Z"
		/>
	</svg>
);
